import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Hidden } from '@material-ui/core';
import Banner from '@cpg-its/ads.containers.banner';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { GenericAccordion } from '../../../../global/components/generic-accordion';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { MainContent } from '../../../../global/components/layout/main-content-container';
import { PageContainer } from '../../../../global/components/layout/page-container';
import { PageHeader } from '../../../../global/components/layout/page-header';
import { WysiwygWithReactLink } from '../../../../global/components/wysiwyg-with-react-link';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { accordionOverrideStyles } from '../../../../global/constants/theme/styles/components/generic-accordion';
import { useBasePath } from '../../../../global/hooks/useBasePath';
import { TcsmStates } from '../../../../root/tcsm-model';
import { ArcRoutes } from '../../../arc/constants/routes';
import { AccountInfoRoutes } from '../../constants/routes';
import { PersonalInfoProps } from '../../models/account-info-epi-props';
import { DomesticPartnerFormAction } from '../domestic-partner/model/domestic-partner-form-models';
import { QueryArrayMessage } from '../../../../global/components/messages/query-array-message';
import { FormTypes } from '../../models/form-models';
import { useGetMidYearPendingApproval } from '../../../../Global/hooks/useGetMidYearPendingApproval';
import { MycpgMidyearPendingApprovalNotification } from '../../../notification/mycpg-midyear-pending-approval-notification';
import { TcsmAppConfigs } from '../../../../global/models/configuration-models';
import { QualifyingEventType } from '../mycpg-midyear/models/mycpg-mid-year-models';
import { ChildTypes } from '../dependents/dependents-model';
import { SideBarContent } from '../../../../global/components/layout/sidebar-content';
import { GuidedProcessSupportBlock } from '../../../../global/components/guided-process-support-block';
import { useGpsType } from '../../../../global/hooks/useGpsType';
import { GpsType } from '../../../../global/components/layout/layout-models';
import { DividerSection } from '../../../../../stories/divider-section';
import { AccordionHeader } from '../../../../Global/components/layout/accordion-header';

interface Props {
    appConfig: TcsmAppConfigs;
}


export const LifeEventsLanding = (props: Props) => {


    const { appConfig } = props;
    const settings = useSelector<TcsmStates, PersonalInfoProps>(state => state?.epiProps?.personalInfoSettingState?.epiContent);
    const gpsItem = useGpsType(GpsType.LIFE_EVENTS_LANDING);
    const buttonClasses = buttonStyles();
    const accordionClasses = accordionOverrideStyles();
    const [expand, setExpand] = useState(false);
    const history = useHistory();
    const maritalStatusLink = useBasePath(`${AccountInfoRoutes.MyCpgRoot}${AccountInfoRoutes.RelationshipsSegment}${AccountInfoRoutes.MaritalStatusSegment}`);
    const domesticPartnerStatusLink = useBasePath(`${AccountInfoRoutes.MyCpgRoot}${AccountInfoRoutes.RelationshipsSegment}${AccountInfoRoutes.DomesticPartner}`);
    const childStatusLink = useBasePath(`${AccountInfoRoutes.MyCpgRoot}${AccountInfoRoutes.RelationshipsSegment}${AccountInfoRoutes.DependentSegment}`);

    const pendingForApprovalEnrollment = useGetMidYearPendingApproval();

    const domesticPartnerLink = `${domesticPartnerStatusLink}?action=death`;
    const childDeathLink = useBasePath(`${AccountInfoRoutes.MyCpgRoot}${AccountInfoRoutes.RelationshipsSegment}${AccountInfoRoutes.DeathOfChild}`);
    const qualifyingEventLink = useBasePath(`${AccountInfoRoutes.MyCpgRoot}${ArcRoutes.QualifyingEvent}`);
    const lifeEventRootLink = useBasePath(`${AccountInfoRoutes.MyCpgRoot}${ArcRoutes.LifeEvents}`);
    const dependentGainingOwnBenefitsLink = `${qualifyingEventLink}?eventType=${QualifyingEventType.dependent_gaining_own_benefits}`;
    const judgementDecreeLink = `${qualifyingEventLink}?eventType=${QualifyingEventType.judgment_decree_or_order}`;
    const spouseDomesticPartnerStatusChangeLink = `${qualifyingEventLink}?eventType=${QualifyingEventType.spouse_or_domestic_partner_status_change}`;
    const lossOfCoverageLink = `${qualifyingEventLink}?eventType=${QualifyingEventType.loss_of_coverage}`;
    const changeCoverageCostCurtailmentLink = `${qualifyingEventLink}?eventType=${QualifyingEventType.change_in_coverage_cost_or_curtailment}`;
    const eligibilityChangeMedicareMedicaidSchpLink = `${lifeEventRootLink}${AccountInfoRoutes.HealthPlanEligibility}`;
    const enrollmentThroughHealthInsuranceExchangeLink = `${qualifyingEventLink}?eventType=${QualifyingEventType.enrollment_through_health_insurance_exchange}`;
    const medicarePartDEnrollmentTerminationLink = `${lifeEventRootLink}${AccountInfoRoutes.MedicarePartD}`;

    const onClick = (url: string) => {
        history.push(url);
    };
    const setExpandAction = () => {
        setExpand(!expand);
    };

    if (!pendingForApprovalEnrollment) {
        return <LoadingCircle />;
    }

    return (
        <>
            <PageContainer>
                <MainContent>
                    <PageHeader
                        headerText={settings?.lifeEventsTitle}
                    />
                    <Hidden mdUp>
                        <SideBarContent>
                            <GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
                        </SideBarContent>
                    </Hidden>
                    <ContentSpacer>
                        {
                            pendingForApprovalEnrollment && pendingForApprovalEnrollment?.length > 0 ?
                                <MycpgMidyearPendingApprovalNotification appConfig={appConfig} />
                                :
                                <Banner
                                    banner={{
                                        type: 'warning',
                                        label: <WysiwygWithReactLink content={settings?.lifeEventsPageDescription} />,

                                    }}
                                />
                        }
                    </ContentSpacer>
                    <QueryArrayMessage
                        queryKey='success'
                        useWarnings={[FormTypes.LIFE_EVENT_30_PLUS]}
                    />
                    <div className={`${accordionClasses.accordionContainer} border-bottom`}>
                        <AccordionHeader>
                            <WysiwygWithReactLink content={settings?.lifeEventsAccordionIntro} />
                            <button onClick={setExpandAction} type='button' className={buttonClasses.linkButton}>{expand ? 'Collapse All' : 'Expand All'}</button>
                        </AccordionHeader>
                        <GenericAccordion expand={expand} titleText={settings?.maritalPartnershipTitle}>
                            <div className='rich-text'>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(maritalStatusLink)}>{settings?.marriageLinkLabel}</button></p>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(maritalStatusLink)}>{settings?.divorceLinkLabel}</button></p>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(maritalStatusLink)}>{settings?.legalSeparationLinkLabel}</button>
                                </p>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(domesticPartnerStatusLink)}>{settings?.domesticPartnershipLinkLabel}</button></p>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(`${domesticPartnerStatusLink}?action=${DomesticPartnerFormAction.DISSOLUTION}`)}>{settings?.domesticPartnershipEndLinkLabel}</button></p>
                            </div>
                        </GenericAccordion>
                        <GenericAccordion expand={expand} titleText={settings?.addingChildrenTitle}>
                            <ContentSpacer>
                                <div className='rich-text'>
                                    <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(`${childStatusLink}?childType=${ChildTypes.legal}`)}>{settings?.childLinkLabel}</button></p>
                                    <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(`${childStatusLink}?childType=${ChildTypes.adopted}`)}>{settings?.adoptChildLinkLabel}</button></p>
                                    <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(`${childStatusLink}?childType=${ChildTypes.step}`)}>{settings?.stepChildLinkLabel}</button></p>
                                </div>
                            </ContentSpacer>
                            <DividerSection greySection removeDivider>
                                <div className='rich-text'>
                                    <h5>{settings?.relatedIssuesLabel}</h5>
                                    <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(judgementDecreeLink)}>{settings?.judgementDecreeLinkLabel}</button></p>
                                </div>
                            </DividerSection>
                        </GenericAccordion>
                        <GenericAccordion expand={expand} titleText={settings?.changeHealthCoverageTitle}>
                            <div className='rich-text'>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(dependentGainingOwnBenefitsLink)}>{settings?.dependentHealthBenefitsLinkLabel}</button></p>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(spouseDomesticPartnerStatusChangeLink)}>{settings?.changeDomesticPartnerStatusLinkLabel}</button></p>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(lossOfCoverageLink)}>{settings?.lossOfCoverageLinkLabel}</button></p>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(changeCoverageCostCurtailmentLink)}>{settings?.changeinCostLinkLabel}</button></p>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(eligibilityChangeMedicareMedicaidSchpLink)}>{settings?.eligibilityMedicareLinkLabel}</button></p>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(medicarePartDEnrollmentTerminationLink)}> {settings?.medicareEnrolllmentTerminationLinkLabel} </button></p>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(enrollmentThroughHealthInsuranceExchangeLink)}> {settings?.healthPlanEnrollmentLinkLable} </button></p>
                            </div>
                        </GenericAccordion>
                        <GenericAccordion expand={expand} titleText={settings?.deathTitle} >
                            <div className='rich-text'>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(maritalStatusLink)}>{settings?.spouseDeathLinkLabel}</button></p>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(domesticPartnerLink)}>{settings?.domesticPartnerDeathLinkLabel}</button></p>
                                <p><button className={buttonClasses.linkButton} type='button' onClick={() => onClick(childDeathLink)}>{settings?.childDeathLinkLabel}</button></p>
                            </div>
                        </GenericAccordion>
                    </div>
                    <WysiwygWithReactLink content={settings?.lifeEventsContactText} />
                </MainContent >
                <Hidden smDown>
                    <SideBarContent>
                        <GuidedProcessSupportBlock title={gpsItem?.title} contents={gpsItem?.contents} />
                    </SideBarContent>
                </Hidden>
            </PageContainer >

        </>
    );
};